import httpClient from './httpClient'

export default {
  PromotionalDevice: {
    IsPromotionalDevice(payload) {
      return httpClient.get(
        `/PromotionalDevice/IsPromotionalDevice?serialNumber=${payload.serialNumber}`
      )
    },
  },
}
